import Paper from '@mui/material/Paper';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

export const TabPaper: React.FC<React.PropsWithChildren> = (
  props: React.PropsWithChildren,
): React.ReactElement => {
  const { children } = props;

  return (
    <Paper sx={styles.tabContent} elevation={1}>
      {children}
    </Paper>
  );
};

const styles: Record<string, SystemStyleObject> = {
  tabContent: {
    backgroundColor: 'custom.White',
    py: 5,
    px: 4,
    mb: 4,
  },
};
